import React, { useMemo, useState } from 'react'
import { Tabs } from 'antd';
import Infos from './Infos.js';
import Admins from './Admins.js';

const Settings = ({ page, setPage, setIsLoading }) => {
  const [activeTab, setActiveTab] = useState('1');

  const handleTabChange = (key) => {
    console.log('Tab changed to:', key);
    setActiveTab(key);
  };

  const tabItems = useMemo(() => [
    {
      key: '1',
      label: 'Informations',
      children: <Infos page={page} setIsLoading={setIsLoading} />
    },
    {
      key: '2',
      label: 'Administrateurs',
      children: <Admins page={page} setPage={setPage} setIsLoading={setIsLoading} />
    },
  ], [page, setPage, setIsLoading]);

  return (
    <div className='h-full m-4 md:w-full'>
      <Tabs 
        activeKey={activeTab}
        type="card" 
        items={tabItems} 
        onChange={handleTabChange} 
      />
    </div>
  );
};

export default Settings;